import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { UserInfo } from '../interfaces/api.interface';

export const userResolver: ResolveFn<UserInfo | null> = (route, state) => {
  const authService = inject(AuthService);

  // If user is already loaded in auth service, return it — once an /auth/me in flight has answered: after a
  // reload on a password session the stored user is the sign-in payload (the main row). Its failure keeps that user.
  const currentUser = authService.user();
  if (currentUser && authService.isAuthenticated()) {
    const pending = authService.pendingUserRefresh();
    return pending ? pending.then(() => authService.user(), () => authService.user()) : of(currentUser);
  }

  // If not authenticated, return null immediately
  if (!authService.isAuthenticated()) {
    return of(null);
  }

  // Only fetch from API if we have a token but no user data
  return authService.getCurrentUser().pipe(
    map(userData => {
      if (userData) {
        authService.updateUser(userData);
        return userData;
      }
      return null;
    }),
    catchError(() => {
      // If API call fails, return null
      return of(null);
    })
  );
}; 